import { Link } from "react-router-dom";
import Sidebar from "./Sidebar";
import { FaLongArrowAltLeft, FaSun } from "react-icons/fa";
import { IoSettingsOutline } from "react-icons/io5";
import { useEffect, useState } from "react";

const FOOD_APPS_BY_COUNTRY = {
    IN: [
        { name: "Zomato", url: "https://www.zomato.com", color: "#fa7777", rating: 4.4 },
        { name: "Swiggy", url: "https://www.swiggy.com", color: "#22c55e", rating: 4.5 },
    ],

    US: [
        { name: "Uber Eats", url: "https://www.ubereats.com", color: "#f97316", rating: 4.6 },
        { name: "DoorDash", url: "https://www.doordash.com", color: "#a855f7", rating: 4.7 },
        { name: "Grubhub", url: "https://www.grubhub.com", color: "#eb4034", rating: 4.5 },
        { name: "Postmates", url: "https://postmates.com", color: "#8b5cf6", rating: 4.4 },
    ],

    AE: [
        { name: "Talabat", url: "https://www.talabat.com", color: "#aeeb34", rating: 4.6 },
        { name: "Careem NOW", url: "https://www.careem.com", color: "#2af5e4", rating: 4.4 },
        { name: "Deliveroo", url: "https://deliveroo.ae", color: "#2a52f5", rating: 4.5 },
    ],

    GB: [
        { name: "Deliveroo", url: "https://deliveroo.co.uk", color: "#6d2af5", rating: 4.6 },
        { name: "Just Eat", url: "https://www.just-eat.co.uk", color: "#b119f7", rating: 4.4 },
        { name: "Uber Eats", url: "https://www.ubereats.com", color: "#f719e5", rating: 4.5 },
    ],

    JP: [
        { name: "Uber Eats", url: "https://www.ubereats.com", color: "#16a34a", rating: 4.3 },
        { name: "Demae-can", url: "https://demae-can.com", color: "#dc2626", rating: 4.2 },
        { name: "Rakuten Delivery", url: "https://delivery.rakuten.co.jp", color: "#ef4444", rating: 4.1 },
    ],

    CN: [
        { name: "Meituan", url: "https://www.meituan.com", color: "#6d2af5", rating: 4.6 },
        { name: "Ele.me", url: "https://www.ele.me", color: "#b119f7", rating: 4.5 },
    ],

    SG: [
        { name: "GrabFood", url: "https://www.grab.com", color: "#22c55e", rating: 4.6 },
        { name: "Foodpanda", url: "https://www.foodpanda.sg", color: "#ec4899", rating: 4.5 },
        { name: "Deliveroo", url: "https://deliveroo.sg", color: "#6366f1", rating: 4.4 },
    ],

    AU: [
        { name: "Uber Eats", url: "https://www.ubereats.com", color: "#16a34a", rating: 4.5 },
        { name: "Menulog", url: "https://www.menulog.com.au", color: "#f97316", rating: 4.4 },
    ],

    CA: [
        { name: "Uber Eats", url: "https://www.ubereats.com", color: "#22c55e", rating: 4.6 },
        { name: "DoorDash", url: "https://www.doordash.com", color: "#ef4444", rating: 4.7 },
        { name: "SkipTheDishes", url: "https://www.skipthedishes.com", color: "#facc15", rating: 4.5 },
    ],

    ID: [
        { name: "GoFood", url: "https://www.gojek.com", color: "#22c55e", rating: 4.6 },
        { name: "GrabFood", url: "https://www.grab.com", color: "#16a34a", rating: 4.5 },
    ],

    DE: [
        { name: "Lieferando", url: "https://www.lieferando.de", color: "#f97316", rating: 4.5 },
        { name: "Wolt", url: "https://wolt.com", color: "#3b82f6", rating: 4.6 },
        { name: "Uber Eats", url: "https://www.ubereats.com", color: "#16a34a", rating: 4.4 },
    ],

    FR: [
        { name: "Uber Eats", url: "https://www.ubereats.com", color: "#16a34a", rating: 4.6 },
        { name: "Deliveroo", url: "https://deliveroo.fr", color: "#6366f1", rating: 4.5 },
        { name: "Just Eat", url: "https://www.just-eat.fr", color: "#ec4899", rating: 4.4 },
    ],

    IT: [
        { name: "Deliveroo", url: "https://deliveroo.it", color: "#4f46e5", rating: 4.5 },
        { name: "Just Eat", url: "https://www.justeat.it", color: "#f97316", rating: 4.4 },
        { name: "Uber Eats", url: "https://www.ubereats.com", color: "#22c55e", rating: 4.3 },
    ],

    ES: [
        { name: "Glovo", url: "https://glovoapp.com", color: "#facc15", rating: 4.6 },
        { name: "Uber Eats", url: "https://www.ubereats.com", color: "#16a34a", rating: 4.5 },
        { name: "Just Eat", url: "https://www.just-eat.es", color: "#ec4899", rating: 4.4 },
    ],

    BR: [
        { name: "iFood", url: "https://www.ifood.com.br", color: "#dc2626", rating: 4.6 },
        { name: "Uber Eats", url: "https://www.ubereats.com", color: "#16a34a", rating: 4.4 },
    ],

    MX: [
        { name: "Rappi", url: "https://www.rappi.com", color: "#f97316", rating: 4.6 },
        { name: "Uber Eats", url: "https://www.ubereats.com", color: "#16a34a", rating: 4.5 },
    ],

    KR: [
        { name: "Baemin", url: "https://www.baemin.com", color: "#06b6d4", rating: 4.6 },
        { name: "Yogiyo", url: "https://www.yogiyo.co.kr", color: "#ec4899", rating: 4.5 },
    ],

    VN: [
        { name: "GrabFood", url: "https://www.grab.com", color: "#16a34a", rating: 4.6 },
        { name: "ShopeeFood", url: "https://shopeefood.vn", color: "#f97316", rating: 4.4 },
    ],

    PH: [
        { name: "GrabFood", url: "https://www.grab.com", color: "#22c55e", rating: 4.6 },
        { name: "Foodpanda", url: "https://www.foodpanda.ph", color: "#ec4899", rating: 4.5 },
    ],

    TH: [
        { name: "GrabFood", url: "https://www.grab.com", color: "#16a34a", rating: 4.6 },
        { name: "Foodpanda", url: "https://www.foodpanda.co.th", color: "#ec4899", rating: 4.5 },
    ],

    NL: [
        { name: "Thuisbezorgd", url: "https://www.thuisbezorgd.nl", color: "#f97316", rating: 4.5 },
        { name: "Uber Eats", url: "https://www.ubereats.com", color: "#16a34a", rating: 4.4 },
    ],

    SE: [
        { name: "Foodora", url: "https://www.foodora.se", color: "#ec4899", rating: 4.6 },
        { name: "Wolt", url: "https://wolt.com", color: "#3b82f6", rating: 4.7 },
    ],

    NO: [
        { name: "Foodora", url: "https://www.foodora.no", color: "#ec4899", rating: 4.6 },
        { name: "Wolt", url: "https://wolt.com", color: "#3b82f6", rating: 4.7 },
    ],

    FI: [
        { name: "Wolt", url: "https://wolt.com", color: "#3b82f6", rating: 4.8 },
        { name: "Foodora", url: "https://www.foodora.fi", color: "#ec4899", rating: 4.5 },
    ],

    PL: [
        { name: "Pyszne.pl", url: "https://www.pyszne.pl", color: "#f97316", rating: 4.5 },
        { name: "Uber Eats", url: "https://www.ubereats.com", color: "#16a34a", rating: 4.4 },
    ],

    CZ: [
        { name: "Dáme Jídlo", url: "https://www.damejidlo.cz", color: "#f97316", rating: 4.5 },
        { name: "Wolt", url: "https://wolt.com", color: "#3b82f6", rating: 4.6 },
    ],

    HU: [
        { name: "Wolt", url: "https://wolt.com", color: "#3b82f6", rating: 4.6 },
        { name: "Foodpanda", url: "https://www.foodpanda.hu", color: "#ec4899", rating: 4.5 },
    ],

    CH: [
        { name: "Uber Eats", url: "https://www.ubereats.com", color: "#16a34a", rating: 4.6 },
        { name: "Smood", url: "https://www.smood.ch", color: "#f97316", rating: 4.4 },
    ],
    AT: [
        { name: "Lieferando", url: "https://www.lieferando.at", color: "#f97316", rating: 4.5 },
        { name: "Mjam", url: "https://www.mjam.net", color: "#ec4899", rating: 4.4 },
    ],
    IE: [
        { name: "Just Eat", url: "https://www.just-eat.ie", color: "#ec4899", rating: 4.5 },
        { name: "Deliveroo", url: "https://deliveroo.ie", color: "#6366f1", rating: 4.4 },
    ],
    PT: [
        { name: "Uber Eats", url: "https://www.ubereats.com", color: "#16a34a", rating: 4.5 },
        { name: "Glovo", url: "https://glovoapp.com", color: "#facc15", rating: 4.6 },
    ],
    GR: [
        { name: "efood", url: "https://www.e-food.gr", color: "#ef4444", rating: 4.7 },
        { name: "Wolt", url: "https://wolt.com", color: "#3b82f6", rating: 4.5 },
    ],
    TR: [
        { name: "Yemeksepeti", url: "https://www.yemeksepeti.com", color: "#ef4444", rating: 4.6 },
        { name: "Getir", url: "https://getir.com", color: "#7c3aed", rating: 4.5 },
    ],
    SA: [
        { name: "HungerStation", url: "https://hungerstation.com", color: "#22c55e", rating: 4.6 },
        { name: "Jahez", url: "https://jahez.net", color: "#f97316", rating: 4.4 },
        { name: "Talabat", url: "https://www.talabat.com", color: "#facc15", rating: 4.5 },
    ],
    QA: [
        { name: "Talabat", url: "https://www.talabat.com", color: "#facc15", rating: 4.6 },
        { name: "Snoonu", url: "https://www.snoonu.com", color: "#3b82f6", rating: 4.4 },
    ],
    KW: [
        { name: "Talabat", url: "https://www.talabat.com", color: "#facc15", rating: 4.6 },
        { name: "Carriage", url: "https://www.trycarriage.com", color: "#ec4899", rating: 4.4 },
    ],
    EG: [
        { name: "Talabat", url: "https://www.talabat.com", color: "#facc15", rating: 4.6 },
        { name: "Elmenus", url: "https://www.elmenus.com", color: "#ef4444", rating: 4.5 },
    ],
    MY: [
        { name: "GrabFood", url: "https://www.grab.com", color: "#16a34a", rating: 4.6 },
        { name: "Foodpanda", url: "https://www.foodpanda.my", color: "#ec4899", rating: 4.5 },
    ],
    PK: [
        { name: "Foodpanda", url: "https://www.foodpanda.pk", color: "#ec4899", rating: 4.4 },
        { name: "Careem NOW", url: "https://www.careem.com", color: "#06b6d4", rating: 4.3 },
    ],
    BD: [
        { name: "Foodpanda", url: "https://www.foodpanda.com.bd", color: "#ec4899", rating: 4.3 },
        { name: "HungryNaki", url: "https://hungrynaki.com", color: "#f97316", rating: 4.1 },
    ],
    LK: [
        { name: "Uber Eats", url: "https://www.ubereats.com", color: "#16a34a", rating: 4.2 },
        { name: "PickMe Food", url: "https://pickme.lk", color: "#3b82f6", rating: 4.4 },
    ],
    ES: [
        { name: "Glovo", url: "https://glovoapp.com", color: "#facc15", rating: 4.6 },
        { name: "Just Eat", url: "https://www.just-eat.es", color: "#ec4899", rating: 4.4 },
    ],

    AR: [
        { name: "PedidosYa", url: "https://www.pedidosya.com.ar", color: "#ef4444", rating: 4.6 },
        { name: "Rappi", url: "https://www.rappi.com", color: "#f97316", rating: 4.4 },
    ],
    CO: [
        { name: "Rappi", url: "https://www.rappi.com", color: "#f97316", rating: 4.7 },
        { name: "iFood", url: "https://www.ifood.com.br", color: "#ef4444", rating: 4.5 },
    ],
    PE: [
        { name: "PedidosYa", url: "https://www.pedidosya.pe", color: "#ef4444", rating: 4.5 },
        { name: "Rappi", url: "https://www.rappi.com", color: "#f97316", rating: 4.4 },
    ],
    TW: [
        { name: "Foodpanda", url: "https://www.foodpanda.com.tw", color: "#ec4899", rating: 4.6 },
        { name: "Uber Eats", url: "https://www.ubereats.com", color: "#16a34a", rating: 4.5 },
    ],
    NZ: [
        { name: "Uber Eats", url: "https://www.ubereats.com", color: "#16a34a", rating: 4.6 },
        { name: "Delivereasy", url: "https://www.delivereasy.co.nz", color: "#f97316", rating: 4.4 },
    ],
    ZA: [
        { name: "Mr D Food", url: "https://www.mrdfood.com", color: "#ef4444", rating: 4.6 },
        { name: "Uber Eats", url: "https://www.ubereats.com", color: "#16a34a", rating: 4.4 },
    ],
    NG: [
        { name: "Jumia Food", url: "https://food.jumia.com.ng", color: "#f97316", rating: 4.3 },
        { name: "Bolt Food", url: "https://food.bolt.eu", color: "#22c55e", rating: 4.4 },
    ],
    KE: [
        { name: "Glovo", url: "https://glovoapp.com", color: "#facc15", rating: 4.5 },
        { name: "Jumia Food", url: "https://food.jumia.co.ke", color: "#f97316", rating: 4.3 },
    ],
    MA: [
        { name: "Glovo", url: "https://glovoapp.com", color: "#facc15", rating: 4.5 },
        { name: "Jumia Food", url: "https://food.jumia.ma", color: "#f97316", rating: 4.2 },
    ],
    PH: [
        { name: "GrabFood", url: "https://www.grab.com", color: "#16a34a", rating: 4.6 },
        { name: "Foodpanda", url: "https://www.foodpanda.ph", color: "#ec4899", rating: 4.5 },
    ],
    RO: [
        { name: "Glovo", url: "https://glovoapp.com", color: "#facc15", rating: 4.6 },
        { name: "Tazz", url: "https://tazz.ro", color: "#3b82f6", rating: 4.4 },
    ],

};

export default function Foodapps() {
    const [countries, setCountries] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [searchValue, setSearchValue] = useState("")
    const [visibleApps, setVisibleApps] = useState([]);

    const [theme, setTheme] = useState(localStorage.getItem("theme") || "dark");

    useEffect(() => {
        const savedTheme = localStorage.getItem("theme") || "dark";
        setTheme(savedTheme);
    }, []);

    const pageBg = theme === "dark" ? "dashboard-bg" : "bg-light";
    const cardBg = theme === "dark" ? "backgroundd-bg text-light" : "bg-white text-dark";
    const inputBg = theme === "dark" ? "form-control w-100 border-0" : "bg-light shadow-sm text-dark";
    const btnSecondary = theme === "dark" ? "btn btn-dark text-light" : "btn btn-gradientss text-light";
    const btnMain = theme === "dark" ? "btn btn-gradientss text-light" : "btn btn-gradientss text-light";
    const textColor = theme === "dark" ? "text-light" : "text-dark";

    useEffect(() => {
        fetch("https://restcountries.com/v3.1/all?fields=name,cca2,flags")
            .then((res) => res.json())
            .then((data) => {
                const sorted = data
                    .filter((c) => c.cca2) // 🔒 safety
                    .sort((a, b) =>
                        a.name.common.localeCompare(b.name.common)
                    );

                setCountries(sorted);
                setLoading(false);
            })
            .catch((err) => {
                console.error("Countries fetch error:", err);
                setLoading(false);
            });
    }, []);

    function handleSelect(value) {
        setSearchValue(value);
        const found = countries.find(
            c => c.name.common === value
        );
        if (found) {
            setSelectedCountry(found);
            setVisibleApps(
                FOOD_APPS_BY_COUNTRY[found.cca2] || []
            );
        }
    }

    return (
        <>
            <title>Best Food Delivery Apps Worldwide by Country | TravelToolkit</title>
            <meta name="description" content="Discover the best food delivery apps in every country. TravelToolkit helps you find top-rated apps like Uber Eats, Zomato, Swiggy, and more wherever you travel." />
            <meta name="keywords" content="food delivery apps worldwide, best food apps by country, Uber Eats alternatives, Zomato Swiggy global apps, food delivery international, apps for ordering food abroad" />

            <meta property="og:title" content="Best Food Delivery Apps Worldwide by Country | TravelToolkit" />
            <meta property="og:site_name" content="traveltoolkit" />
            <meta property="og:url" content="https://traveltoolkit.online/Foodapps" />
            <meta property="og:description" content="Discover the best food delivery apps in every country. TravelToolkit helps you find top-rated apps like Uber Eats, Zomato, Swiggy, and more wherever you travel." />
            <meta property="og:image" content="earth.gif"></meta>

            <meta name="twitter:card" content="app" />
            <meta name="twitter:site" content="@traveltoolkit" />
            <meta name="twitter:description" content="Discover the best food delivery apps in every country. TravelToolkit helps you find top-rated apps like Uber Eats, Zomato, Swiggy, and more wherever you travel." />
            <meta name="twitter:app:country" content="India" />

            <div className="container-fluid p-0">
                <div className="row g-0">
                    <Sidebar />
                    <div className={`col-md-9 col-lg-10 ${pageBg} min-vh-100 p-3 offset-lg-2 offset-md-2`}>
                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <div className="d-flex align-items-center gap-2">
                                <Link to="/Dashboard">
                                    <button className={btnSecondary}>
                                        <FaLongArrowAltLeft />
                                    </button>
                                </Link>
                                <h1 className={`${textColor} mb-0 h4`}>
                                    Food Delivery Apps
                                </h1>
                            </div>
                            <Link to="/Settings">
                                <button className="btn btn-gradientss text-light">
                                    <IoSettingsOutline />
                                </button>
                            </Link>
                        </div>
                        {loading ? (
                            <p className={textColor}>
                                Loading countries...
                            </p>
                        ) : (
                            <div className="mb-4 d-flex flex-row align-items-center justify-content-between px-4">
                                <div>
                                    <label className={`form-label ${textColor}`}>
                                        Search & Select Country
                                    </label>
                                    <input list="country-list" className={`form-control w-100 border-0 ${inputBg}`} placeholder="Type country name..." value={searchValue} onChange={(e) => handleSelect(e.target.value)} />
                                    <datalist id="country-list">
                                        {countries.map(country => (
                                            <option
                                                key={country.cca2}
                                                value={country.name.common}
                                            />
                                        ))}
                                    </datalist>
                                </div>
                                {selectedCountry && (
                                    <div className={`${textColor} mt-2 small`}>
                                        🌍 <b>{selectedCountry.name.common}</b>
                                        &nbsp;({selectedCountry.cca2})
                                    </div>
                                )}
                            </div>
                        )}
                        {selectedCountry && (
                            <>
                                <h5 className={`mb-3 ${textColor}`}>
                                    🍽 Food Delivery apps in {selectedCountry.name.common}
                                </h5>
                                {visibleApps.length === 0 ? (
                                    <p className={textColor}>
                                        No food delivery apps mapped yet.
                                    </p>
                                ) : (
                                    <div className="row">
                                        {visibleApps.map((app, index) => (
                                            <div className="col-md-4 mb-3" key={index}>
                                                <div className={`card h-100 ${cardBg} shadow p-3 align-items-start`}>
                                                    <div className="app-icon text-light fw-bold" style={{ backgroundColor: app.color }}>
                                                        {app.name.charAt(0)}
                                                    </div>
                                                    <h6 className="mt-2">
                                                        {app.name}
                                                    </h6>
                                                    <div className="app-meta mb-2">
                                                        ⭐ {app.rating}
                                                    </div>
                                                    <a href={app.url} target="_blank" rel="noreferrer" className={`text-decoration-none form-control text-center ${btnMain}`}>
                                                        Open App
                                                    </a>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}